export enum AilosApiAmbiente {
  HOMOLOGACAO,
  PRODUCAO,
}